import {Activity, ActivityType} from '../activity';
import {Definition} from '../definition';
import {ActorType} from '../enumerations/actor-type';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class UpdateResourcesActivity extends Activity {
  public UpdatesTable: Definition[];
  public Advanced: boolean;
  public QueryResources: boolean;
  public QueriesTable: Definition[];
  public ActivityExecutionCondition: string;
  public Iteration: string;
  public ActorType: ActorType;
  public ActorString: string;
  public ApplyAuthorizationPolicy: boolean;
  public ResolveDynamicGrammar: boolean;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.UpdateResources);
    this._properties['UpdatesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['QueryResources'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['QueriesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['Iteration'] = ActivityPropertyDataType.STRING;
    this._properties['ActorType'] = ActivityPropertyDataType.ACTOR_TYPE;
    this._properties['ActorString'] = ActivityPropertyDataType.STRING;
    this._properties['ApplyAuthorizationPolicy'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['ResolveDynamicGrammar'] = ActivityPropertyDataType.BOOLEAN;
    this._advancedProperties = [
      'QueryResources',
      'QueriesTable',
      'ActivityExecutionCondition',
      'Iteration',
      'ActorType',
      'ActorString',
      'ApplyAuthorizationPolicy',
      'ResolveDynamicGrammar',
    ];
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();
    if (this.QueryResources === false) {
      this.QueriesTable = null;
    }

    if (this.ActorType !== ActorType.Resolve && this.ActorType !== ActorType.Account) {
      this.ActorString = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('update-resources', this.dialogConfig);
  }
}
